import { render, staticRenderFns } from "./MyCabinetMenu.vue?vue&type=template&id=4404644c&scoped=true"
import script from "./MyCabinetMenu.vue?vue&type=script&lang=js"
export * from "./MyCabinetMenu.vue?vue&type=script&lang=js"
import style0 from "./MyCabinetMenu.vue?vue&type=style&index=0&id=4404644c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404644c",
  null
  
)

export default component.exports